import React from 'react'
// Local
import If from '../common/if'
import SuccessIcon from './SuccessIcon'
import ErrorIcon from './ErrorIcon'
import WarningIcon from './WarningIcon'
import InfoIcon from './InfoIcon'

const coachingBoxTypes = {
  success: 'success',
  error: 'error',
  infoNegative: 'info-negative',
  infoPositive: 'info-positive'
} as const

type Props = {
  coachingBoxType: keyof typeof coachingBoxTypes
  isShowing: boolean
  message: JSX.Element
}

function ReveleerCoachingBox(
  props: Props
): JSX.Element | null {
  const {
    coachingBoxType,
    message,
    isShowing
  } = props

  if (!isShowing) return null

  const boxType = coachingBoxTypes[coachingBoxType]

  return (
    <div className={ `reveleer-coaching-box ${boxType}` }>
      <div className="icon">
        <If isTrue={ boxType === coachingBoxTypes.success }>
          <SuccessIcon />
        </If>
        <If isTrue={ boxType === coachingBoxTypes.error }>
          <ErrorIcon />
        </If>
        <If isTrue={ boxType === coachingBoxTypes.infoNegative }>
          <WarningIcon />
        </If>
        <If isTrue={ boxType === coachingBoxTypes.infoPositive }>
          <InfoIcon />
        </If>
      </div>
      <div className="message">
        { message }
      </div>
    </div>
  )
}

export default ReveleerCoachingBox
